import React from 'react';

const BrandLogo = ({ size = "md", showText = true }) => {
  const dimensions = size === "sm" ? "w-6 h-6" : size === "lg" ? "w-12 h-12" : "w-8 h-8";
  
  return (
    <div className="flex items-center gap-3">
      <div className={`${dimensions} relative flex-shrink-0`}>
        {/* Radar Ring */}
        <div className="absolute inset-0 border border-[#00f0ff]/30 rounded-full animate-pulse-soft"></div>
        {/* Core Mark */}
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M10 20L20 10L30 20L20 30L10 20Z" stroke="#00f0ff" strokeWidth="2" strokeLinejoin="round"/>
          <circle cx="20" cy="20" r="4" fill="#00f0ff" className="animate-pulse">
            <animate attributeName="r" values="3;5;3" dur="2s" repeatCount="indefinite" />
          </circle>
          <path d="M20 5V8" stroke="#00f0ff" strokeWidth="2" strokeLinecap="round"/>
          <path d="M20 32V35" stroke="#00f0ff" strokeWidth="2" strokeLinecap="round"/>
          <path d="M35 20H32" stroke="#00f0ff" strokeWidth="2" strokeLinecap="round"/>
          <path d="M8 20H5" stroke="#00f0ff" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>
      {showText && (
        <div className="leading-none">
          <span className="text-[#00f0ff] font-bold tracking-[0.2em] uppercase text-sm block text-glow-blue">FleetForesight</span>
          <span className="text-[8px] font-mono text-gray-500 tracking-[0.3em] uppercase">Tactical Operations</span>
        </div>
      )}
    </div>
  );
};

export default BrandLogo;